(function ($) {
  const $buttonContainer = $('.series-header .hero-buttons');
  const $buttons = $buttonContainer.find('a');

  $buttons.each((index, button) => {
    button.classList.add("btn");
    if (button.classList.contains('openModal')) {
      button.classList.add("btn--primary"); 
      button.classList.add("btn--play");
      button.innerHTML = 'Afspelen';
    } else {
      button.classList.add("btn--white");
      button.classList.add("btn--info");
      button.innerHTML = 'Over de serie';
    }
  })
})(jQuery);